import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import QuoteRequestModal from './QuoteRequestModal';

interface QuoteModalContextValue {
  isOpen: boolean;
  openQuoteModal: () => void;
  closeQuoteModal: () => void;
}

const QuoteModalContext = createContext<QuoteModalContextValue | undefined>(undefined);

export const QuoteModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openQuoteModal = useCallback(() => setIsOpen(true), []);
  const closeQuoteModal = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, openQuoteModal, closeQuoteModal }),
    [closeQuoteModal, isOpen, openQuoteModal]
  );

  return (
    <QuoteModalContext.Provider value={value}>
      {children}
      <QuoteRequestModal open={isOpen} onClose={closeQuoteModal} />
    </QuoteModalContext.Provider>
  );
};

export function useQuoteModal() {
  const context = useContext(QuoteModalContext);
  if (!context) {
    throw new Error('useQuoteModal must be used inside QuoteModalProvider');
  }
  return context;
}
